import gql from 'graphql-tag'

export default gql`
mutation CA_web_deleteAutomationTaskServer($id: ID!) {
	cashAssist {
		deleteAutomationTaskServer(id: $id) {
			id
		}
	}
}`
